module.exports = __webpack_public_path__ + "static/img/013.aa9a8de2.jpg";